import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Countries } from 'src/models/Countries';
import { Currencies } from 'src/models/Currencies';
import { Salutations } from 'src/models/Salutations';

export interface ICoreDataState {
  countries?: Countries;
  currencies?: Currencies;
  salutations?: Salutations;
}

// Todo: Utility not initialized yet "Uncaught ReferenceError: Cannot access 'Utility' before initialization"
function getStore<T>(
  key: 'countries' | 'currencies' | 'salutations'
): T | undefined {
  const value = sessionStorage.getItem(key) || localStorage.getItem(key);

  if (!value) {
    return undefined;
  }

  try {
    const parsedValue = JSON.parse(value, (key, val) => {
      const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

      if (typeof val === 'string' && iso8601Regex.test(val)) {
        return new Date(val);
      }

      return val;
    }) as T;

    return parsedValue;
  } catch (error) {
    // Todo: log error
    return undefined;
  }
}

export const initialCoreDataState: ICoreDataState = {
  countries: getStore<Countries>('countries'),
  currencies: getStore<Currencies>('currencies'),
  salutations: getStore<Salutations>('salutations'),
};

export const selectCoreDataState =
  createFeatureSelector<ICoreDataState>('coreData');

export const selectCountries = createSelector(
  selectCoreDataState,
  (state) => state.countries
);

export const selectCurrencies = createSelector(
  selectCoreDataState,
  (state) => state.currencies
);

export const selectSalutations = createSelector(
  selectCoreDataState,
  (state) => state.salutations
);
